export default function setBodyColor({color}:any) {
    document.documentElement.style.setProperty('--body-bg-color', color);
}